import React from 'react';
import Component from '@/Component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModifyTimeEx extends Component {

  onChangeTime(e) {
    this.props._updateModifyTimeEx(e.target.name, e.target.value)
  }

  onClickSave() {
    this.props._saveModifyTimeEx();
  }

  onClickDelete() {
    this.props._deleteModifyTimeEx();
  }

  render() {
    const {
      isOpen,
      modifyTimeInfo:  {
        firstHour,
        firstMinute,
        lastHour,
        lastMinute,
        modified
      },
      _closeModifyTimeEx,
    } = this.props;

    return (
      <div>
        <Modal isOpen={isOpen} toggle={_closeModifyTimeEx} backdrop="static" centered={true}>
          <ModalHeader toggle={_closeModifyTimeEx}>근무 시간 수정</ModalHeader>
          <ModalBody>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <input name='firstHour' type="number" className="form-control" width={50} value={firstHour} onChange={this.onChangeTime} min="0" max="23" style={{ margin: '0 5px' }} />시
              <input name='firstMinute' type="number" className="form-control" width={50} value={firstMinute} onChange={this.onChangeTime} min="0" max="59" style={{ margin: '0 5px 0 10px' }} />분
              <p style={{ margin: 10 }}>~</p>
              <input name='lastHour' type="number" className="form-control" width={50} value={lastHour} onChange={this.onChangeTime} min="0" max="23" style={{ margin: '0 5px' }} />시
              <input name='lastMinute' type="number" className="form-control" width={50} value={lastMinute} onChange={this.onChangeTime} min="0" max="59" style={{ margin: '0 5px 0 10px' }} />분
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="default" onClick={_closeModifyTimeEx}>Close</Button>
            {modified ? <Button color="danger" onClick={this.onClickDelete}>Delete</Button> : null}
            <Button color="primary" onClick={this.onClickSave}>Save</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ModifyTimeEx;




// WEBPACK FOOTER //
// ./src/components/main/ModifyTimeEx.js